<script>
    import Icon from '../Icon.svelte';
    import arrowRightIcon from '../../assets/icons/arrow-right.svg?raw';
    import employeeIcon from '../../assets/icons/employee.svg?raw'; 

    const { item, onSelect } = $props();

</script>

<button onclick={() => onSelect(item.id)}>
    <figure>
        {#if item.photo}
            <img src={item.photo} alt="" />
        {:else}
            <Icon data={employeeIcon} />
        {/if}
    </figure>

    <span>
        {item.name}
        {#if item.note}
            <small>{item.note}</small>
        {/if}
    </span>

    <Icon data={arrowRightIcon} />
</button>

<style>

    button {
        display: flex;
        align-items: center;
        gap: 1em;

        width: 100%;
        height: 100%;

        background: var(--box-color);
        color: var(--text-color);
        border-radius: 0.5em;
        border: none;
        padding: 0;
        overflow: hidden;

        font-size: 1em;
        font-weight: bold;

        cursor: pointer;
    }

    button figure {
        display: flex;
        margin: 0;
        align-items: center;
        justify-content: center;

        background: var(--box-hover-color);

        width: 3em;
        height: 3em;
    }

    button figure img {
        width: 3em;
        height: 3em;
    }

    button figure :global(svg) {
        width: 1.6em;
        height: 1.6em;
    }

    button > span {
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        text-wrap: nowrap;
        -webkit-line-clamp: 1;
        display: flex;
        flex-direction: column;
    }

    button > span small {
        font-size: 0.8em;
        font-weight: normal;
        opacity: 0.8;
    }

    button > :global(svg:last-child) {
        width: 1.6em;
        height: 1.6em;
        margin-left: auto;
        flex-shrink: 0;
        margin-right: 1em;
    }

</style>
